import React, { Component } from "react";
import HomeAccount from "../home/HomeAccount";
import { Link } from "react-router-dom";
import CloseModalOnFocusOut from "react-escape-outside";

class HomeAccountWrapper extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = { isOpen: false };
  }

  handleEscapeOutside = evt => {
    this.setState({ isOpen: false });
  };

  render() {
    return (
      <CloseModalOnFocusOut onEscapeOutside={this.handleEscapeOutside}>
        <li
          className={
            "topNavItem topNavItemDrop nav-item dropdown accountParent" +
            (this.state.isOpen ? " show" : "")
          }
        >
          <Link
            id="navbarDropdown"
            onClick={e => {
              e.preventDefault();
              this.setState({ isOpen: !this.state.isOpen });
            }}
            to=""
          >
            <i className="icon-man" />
            <span className="hidden-sm-down chevron bottom">Account</span>
          </Link>
          <HomeAccount
            closeModal={this.handleEscapeOutside}
            isOpen={this.state.isOpen}
          />
        </li>
      </CloseModalOnFocusOut>
    );
  }
}
export default HomeAccountWrapper;
